import { FC } from 'react';

import { AnimatePresence, motion } from 'framer-motion';

import { time } from '@ui-furniture/lib/utils';
import { easeOutCubic } from '@ui-furniture/lib/utils/easings';
import { x } from '@ui-furniture/style';

import { ActiveInput } from '../types/active-input';

export const InputArea: FC<{
  input: ActiveInput | null;
  isEditing: boolean;
}> = ({ input, isEditing }) => (
  <x.div>
    <AnimatePresence>
      {input !== null && !isEditing ? (
        <motion.div
          key={input.id}
          initial='hidden'
          animate='visible'
          exit='hidden'
          variants={{
            visible: {
              opacity: 1,
              height: 'auto',
              transition: {
                staggerChildren: time.md,
                staggerDirection: -1,
                ease: easeOutCubic,
              },
            },
            hidden: {
              opacity: 0,
              height: 0,
              transition: {
                staggerChildren: time.md,
                staggerDirection: -1,
                ease: easeOutCubic,
              },
            },
          }}
        >
          {input.input}
        </motion.div>
      ) : null}
    </AnimatePresence>
  </x.div>
);
